const modalMixin = {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data () {
    return {
      valueData: this.value
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}

export default modalMixin
